import { Box, useMediaQuery } from '@mui/material'
import React, { useState } from 'react'
import { Motion } from '../Motion/Motion';

export default function ImageDialog({ children }) {
    const [view, setView] = useState(false);
    const tablet = useMediaQuery("(max-width:900px)");
    return (
        <>
            <Box sx={{
                all: 'unset',
                width: '100vw', height: '100vh', bgcolor: 'rgba(0,0,0,0.65)', display: view ? 'flex' : 'none',
                position: "fixed", top: 0, left: 0, zIndex: "999999", overflow: 'hidden', alignItems: 'center', alignContent: 'center', justifyContent: 'center',

            }} onClick={() => {
                document.body.style.overflow = '';
                setView(false);
            }}>
                <Box sx={{ p: "80px" }}>
                    {children}
                </Box>
            </Box>
            <Motion scale={1.01} disabled={tablet}>
                <Box sx={{ zIndex: 5, cursor: tablet ? 'default' : 'pointer' }} onClick={() => {
                    if (tablet) return;
                    document.body.style.overflow = 'hidden';
                    setView(true);
                }}>
                    {children}
                </Box>
            </Motion>
        </>
    )
}
